import React, { useEffect, useState } from 'react';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(0, 0, 0, 0.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const modalStyle = {
  background: '#fff',
  borderRadius: '10px',
  width: '720px',
  maxHeight: '90vh',
  overflowY: 'auto',
  padding: '24px',
  boxShadow: '0 15px 40px rgba(0, 0, 0, 0.2)',
};

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px',
};

const inputStyle = {
  width: '100%',
  padding: '8px 10px',
  border: '1px solid #d0d7de',
  borderRadius: '6px',
  fontSize: '0.95rem',
};

const sectionStyle = {
  marginBottom: '16px',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  padding: '16px',
};

const sectionTitle = {
  marginBottom: '12px',
  fontWeight: 600,
  color: '#0f172a',
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '12px 16px',
};

const buttonRow = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '10px',
  marginTop: '12px',
};

const primaryButton = {
  padding: '10px 16px',
  background: '#2563eb',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
};

const secondaryButton = {
  ...primaryButton,
  background: '#94a3b8',
};

const initialForm = {
  bankName: '',
  bankAccount: '',
  email: '',
  basePay: '',
  weeklyAllowance: '',
  overtimeAllowance: '',
  annualAllowance: '',
  otherAllowance: '',
  healthInsurance: '',
  longTermCareInsurance: '',
  employmentInsurance: '',
  industrialAccidentInsurance: '',
  incomeTax: '',
  localTax: '',
};

function EditPayrollModal({ isOpen, payroll, onClose, onSubmit, submitting }) {
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (payroll) {
      setForm({
        bankName: payroll.bankName || '',
        bankAccount: payroll.bankAccount || '',
        email: payroll.email || '',
        basePay: payroll.basePay ?? '',
        weeklyAllowance: payroll.weeklyAllowance ?? '',
        overtimeAllowance: payroll.overtimeAllowance ?? '',
        annualAllowance: payroll.annualAllowance ?? '',
        otherAllowance: payroll.otherAllowance ?? '',
        healthInsurance: payroll.healthInsurance ?? '',
        longTermCareInsurance: payroll.longTermCareInsurance ?? '',
        employmentInsurance: payroll.employmentInsurance ?? '',
        industrialAccidentInsurance: payroll.industrialAccidentInsurance ?? '',
        incomeTax: payroll.incomeTax ?? '',
        localTax: payroll.localTax ?? '',
      });
    } else {
      setForm(initialForm);
    }
  }, [payroll]);

  if (!isOpen || !payroll) return null;

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = () => {
    onSubmit(form);
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h3 style={{ margin: 0 }}>급여 수정 - {payroll.Participant?.name || '-'}</h3>
          <button style={secondaryButton} onClick={onClose} disabled={submitting}>
            닫기
          </button>
        </div>

        <div style={sectionStyle}>
          <div style={sectionTitle}>입금 정보</div>
          <div style={gridStyle}>
            <label>
              <div>은행</div>
              <input
                type="text"
                style={inputStyle}
                value={form.bankName}
                onChange={(e) => handleChange('bankName', e.target.value)}
              />
            </label>
            <label>
              <div>계좌번호</div>
              <input
                type="text"
                style={inputStyle}
                value={form.bankAccount}
                onChange={(e) => handleChange('bankAccount', e.target.value)}
              />
            </label>
            <label style={{ gridColumn: 'span 2' }}>
              <div>이메일</div>
              <input
                type="email"
                style={inputStyle}
                value={form.email}
                onChange={(e) => handleChange('email', e.target.value)}
              />
            </label>
          </div>
        </div>

        <div style={sectionStyle}>
          <div style={sectionTitle}>지급액</div>
          <div style={gridStyle}>
            {[
              ['basePay', '기본급'],
              ['weeklyAllowance', '주휴수당'],
              ['overtimeAllowance', '시간외수당'],
              ['annualAllowance', '연차수당'],
              ['otherAllowance', '기타수당'],
            ].map(([key, label]) => (
              <label key={key}>
                <div>{label}</div>
                <input
                  type="number"
                  style={inputStyle}
                  value={form[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                />
              </label>
            ))}
          </div>
        </div>

        <div style={sectionStyle}>
          <div style={sectionTitle}>공제액</div>
          <div style={gridStyle}>
            {[
              ['healthInsurance', '건강보험'],
              ['longTermCareInsurance', '요양보험'],
              ['employmentInsurance', '고용보험'],
              ['industrialAccidentInsurance', '산재보험'],
              ['incomeTax', '소득세'],
              ['localTax', '지방세'],
            ].map(([key, label]) => (
              <label key={key}>
                <div>{label}</div>
                <input
                  type="number"
                  style={inputStyle}
                  value={form[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                />
              </label>
            ))}
          </div>
        </div>

        <div style={buttonRow}>
          <button style={secondaryButton} onClick={onClose} disabled={submitting}>
            취소
          </button>
          <button style={primaryButton} onClick={handleSubmit} disabled={submitting}>
            {submitting ? '저장 중...' : '저장'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditPayrollModal;


